var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { fluid: "", row: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "reception-block",
          attrs: {
            xl8: "",
            lg10: "",
            md12: "",
            "offset-xl2": "",
            "offset-lg1": "",
            "offset-md0": "",
            "pa-3": ""
          }
        },
        [
          _c(
            "v-card",
            {
              staticStyle: { overflow: "visible" },
              attrs: { hover: "", to: _vm.coChannelLink, raised: "" }
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "reception-block__pictor",
                  attrs: { row: "", fluid: "", inset: "" }
                },
                [
                  _c("div", {
                    staticClass: "reception-block__pictor--pink picto-vertical"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "reception-block__pictor--yellow picto-vertical"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "reception-block__pictor--green picto-vertical"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { staticClass: "pa-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", fluid: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: { "d-flex": "", xs3: "", "text-xs-center": "" }
                        },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "reception-block__info",
                              attrs: { "fill-height": "" }
                            },
                            [
                              _c("v-flex", [
                                _c("h2", {
                                  domProps: {
                                    textContent: _vm._s(_vm.coBlockName)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "mx-auto ma-2 reception-block__break-line reception-block__break-line--white"
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  domProps: {
                                    textContent: _vm._s(_vm.coAddress)
                                  }
                                })
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { tile: "", flat: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "mt-3 ml-4 mb-2",
                                      attrs: { row: "" }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "reception-block__content--text",
                                          attrs: { xs7: "" }
                                        },
                                        [
                                          _c(
                                            "v-container",
                                            {
                                              staticClass: "pa-0",
                                              staticStyle: { width: "100%" }
                                            },
                                            [
                                              _c("h2", {
                                                staticClass:
                                                  "primary--text bold",
                                                staticStyle: {
                                                  display: "inline-block"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.coReceptionName
                                                  )
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "reception-block__break-line reception-block__break-line--puple"
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "reception-block__content--margin-bottom",
                                            staticStyle: {
                                              "font-style": "italic"
                                            },
                                            attrs: {
                                              name: "contractor-fullname"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _vm.$route.path.includes(
                                            "vehicle-check"
                                          )
                                            ? _c("span", [
                                                _vm._v(
                                                  " Nombre de problèmes: " +
                                                    _vm._s(
                                                      _vm.coNumberOfKeyItem
                                                    )
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.lblSetting
                                                          .receptionNumberOfKO,
                                                        {
                                                          num:
                                                            _vm.coNumberOfKeyItem
                                                        }
                                                      )
                                                    )
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "mt-2 mr-4 reception-block__content",
                                          attrs: {
                                            xs5: "",
                                            "text-xs-right": ""
                                          }
                                        },
                                        [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting
                                                      .receptionCreatedInfo,
                                                    {
                                                      date: _vm.coCreatedAt,
                                                      creator: _vm.coCreatedBy
                                                    }
                                                  )
                                                ) + " "
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    " reception-block__footer reception-block__footer--gray",
                                  attrs: { tile: "", flat: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { staticClass: "my-1", attrs: { row: "" } },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "reception-block__footer--label",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.receptionStatus
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "reception-block__footer--text"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.lblSetting.lblState[
                                                    _vm.reception.state
                                                  ]
                                                )
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                row: "",
                                                "fill-height": ""
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "secondary",
                                                staticStyle: {
                                                  width: "1.5px !important",
                                                  height: "60%",
                                                  transform: "translateY(20%)",
                                                  "margin-left": "10%"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "secondary",
                                                staticStyle: {
                                                  width: "1.5px !important",
                                                  height: "60%",
                                                  transform: "translateY(20%)",
                                                  "margin-right": "10%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "reception-block__footer--label",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.receptionReference
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "primary--text" },
                                        [
                                          _vm._v(
                                            "  " + _vm._s(_vm.reception.id)
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10faef7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10faef7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/mh-reception/components/mh-reception-list-item/template.html
// module id = null
// module chunks = 